import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ApiV2, Code } from '@.api';
import { useDictionaries } from '@.hooks';
import { Layout } from '@.layout';
import { LinkHelper } from '@/Services';
import { SpClusterFormSupportResource } from '@/Types/serviceProviderClusters';

import { StoreClusterForm, StoreClusterModel } from '../components/StoreClusterForm';

export const StoreClusterCreatePage = () => {
    const navigate = useNavigate();

    const [formSupport, setFormSupport] = useState<SpClusterFormSupportResource>();

    const [dictionaries] = useDictionaries('Companies', 'StoreGroups', 'Stores');

    const companies = dictionaries?.companies || [];
    const storeGroups = dictionaries?.store_groups || [];
    const stores = dictionaries?.stores || [];

    const busyCompaniesIds: number[] = companies
        .filter((company) => {
            return !formSupport?.available_companies_ids?.includes(company.id);
        })
        .map((company) => company.id);

    const busyStoreGroupsIds: number[] = storeGroups
        .filter((storeGroup) => {
            return !formSupport?.available_store_groups_ids?.includes(storeGroup.id);
        })
        .map((storeGroup) => storeGroup.id);

    const busyStoresIds: number[] = stores
        .filter((store) => {
            return !formSupport?.available_store_groups_ids?.includes(store.id);
        })
        .map((store) => store.id);

    useEffect(() => {
        const getFormSupport = async () => {
            const response = await ApiV2.serviceProviderClusters().formSupport();

            if (response.code !== Code.Success) {
                return;
            }

            setFormSupport(response.data.form_support);
        };

        getFormSupport();
    }, []);

    const createStoreCluster = async (model: StoreClusterModel) => {
        const response = await ApiV2.serviceProviderClusters().createCluster({
            name: model.name,
            stores_ids: model.stores,
        });

        if (response.code !== Code.Success) {
            return;
        }

        navigate(LinkHelper.serviceProvider.storeClusterList);
    };

    return (
        <Layout nobg>
            <StoreClusterForm
                title="Create store cluster"
                companies={companies}
                stores={stores}
                storeGroups={storeGroups}
                busyCompaniesIds={busyCompaniesIds}
                busyStoreGroupsIds={busyStoreGroupsIds}
                busyStoresIds={busyStoresIds}
                onSave={createStoreCluster}
                initialState={{
                    storeClusterName: '',
                    selectedStores: [],
                }}
            />
        </Layout>
    );
};
